import {useQuizState} from "./quizContext";

export const useQuizMeta = () => {
    const {quiz} = useQuizState()

    return {
        title: quiz.title || quiz.name,
        ingress: quiz.ingress
    }
}